/**
 * @param {Number} number
 * @param {Number} min
 * @param {Number} max
 * @returns Number
 */
// eslint-disable-next-line import/prefer-default-export
export const limitNumberWithinRange = (number, min, max) =>
  Math.min(Math.max(number, min), max);
